import { useCallback, useMemo, useState } from 'react';
import type { RouteConfigExtended, TabValue } from '@lingoda/router';
import { currentRouteTab, useLocation } from '@lingoda/router';
import type { SyntheticEvent } from 'react';

interface Props {
    routes: RouteConfigExtended[];
    onChange?: () => void;
}

export const useStudentActiveTab = ({ routes, onChange }: Props) => {
    const { pathname } = useLocation();

    const [tabValue, setTabValue] = useState<boolean | TabValue>(false);
    // `pathname` required in deps because `currentRouteTab` works on top of `window.location.pathname`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const routeTab = useMemo(() => currentRouteTab(routes), [pathname]);

    const handleChange = useCallback<(_e: SyntheticEvent, newValue: boolean | TabValue) => void>(
        (_e, newValue) => {
            setTabValue(newValue);
            onChange?.();
        },
        [setTabValue, onChange],
    );

    return {
        currentTabValue: routeTab || tabValue,
        handleChange,
    };
};
